module.exports = __webpack_public_path__ + "static/media/tip_goal_with_blue_bg.03ece945.svg";